<template>
  <div>
    <el-form
      label-position="top"
      :model="user"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
    >
      <el-form-item label="Логин" prop="username">
        <el-input
          placeholder="Введите логин"
          v-model="user.username"
        ></el-input>
      </el-form-item>

      <el-form-item label="Пароль" prop="password">
        <el-input
          placeholder="Введите пароль"
          type="password"
          v-model="user.password"
        ></el-input>
      </el-form-item>

      <el-form-item label="Номер телефона" prop="phoneNumber">
        <el-input
          placeholder="Введите номер телефона"
          v-model="user.phoneNumber"
        ></el-input>
      </el-form-item>

      <el-form-item label="Должность" prop="userPosition">
        <el-input
          placeholder="Укажите должность"
          v-model="user.userPosition"
        ></el-input>
      </el-form-item>

      <el-form-item label="ФИО" prop="fullName">
        <el-input placeholder="Укажите ФИО" v-model="user.fullName"></el-input>
      </el-form-item>

      <el-form-item label="Организация" prop="organization">
        <el-select
          class="searchPole"
          v-model="user.organization"
          filterable
          clearable
          remote
          value-key="id"
          reserve-keyword
          placeholder="Организация"
          :remote-method="searchOrganization"
          @change="changeOrganization"
        >
          <el-option
            v-for="item in organizations.content"
            :key="item.organizationInfo.id"
            :label="item.organizationInfo.name"
            :value="item.organizationInfo"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Роль" prop="fullName">
        <el-select
          clearable
          @change="changeRole"
          class="searchPole"
          v-model="user.role"
          value-key="id"
          placeholder="Роль"
        >
          <el-option
            v-for="item in roleList"
            :key="item.id"
            :label="item.displayValue"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="Объект администрирования"
        prop="organization_admin"
        v-if="user.role.id == 3"
      >
        <el-select
          clearable
          class="searchPole"
          v-model="user.organizationIdAdmin"
          value-key="id"
          placeholder="Объект администрирования"
        >
          <el-option
            v-for="item in OrganizationForManagerList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Доступ" prop="fullName">
        <el-select
          class="searchPole"
          v-model="user.lvldostup"
          value-key="id"
          placeholder="Роль"
        >
          <el-option
            v-for="item in lvldostup"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Блокировать начальные данные">
        <el-checkbox v-model="user.prod"></el-checkbox>
      </el-form-item>

      <el-form-item label="Руководитель" prop="managerId">
        <el-select
          clearable
          :disabled="user.role.title !== 'ROLE_ECOLOG'"
          class="searchPole"
          v-model="user.managerId"
          value-key="userId"
          placeholder="Руководитель"
        >
          <el-option
            v-for="item in managerList"
            :key="item.userId"
            :label="item.fullName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="success" @click="addUser('ruleForm')"
          >Добавить</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "usersAdd",
  data() {
    // eslint-disable-next-line no-unused-vars
    let usernameValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Заполните данные"));
      }

      if (/^[a-zA-Z0-9_]+$/.test(value) === false) {
        return callback(
          new Error("В логине должны быть только латинские буквы")
        );
      }

      if (value.length < 4 || value.length > 20) {
        return callback(new Error("В логине должен быть от 4 до 20 символов"));
      }

      if (parseInt(value.substr(0, 1))) {
        return callback(new Error("Логине должен начинаться с буквы"));
      }

      this.$refs.ruleForm.validateField("username");

      return callback();
    };
    return {
      user: {
        organizationIdAdmin: null,
        username: "",
        password: "",
        fullName: "",
        userPosition: "",
        phoneNumber: "",
        managerId: "",
        organization: {},
        role: {
          id: null,
          title: null,
        },
      },
      lvldostup: [
        {
          id: 0,
          name: "По умолчанию",
        },
        {
          id: 1,
          name: "ВПУ + Р. + Б.",
        },
        {
          id: 2,
          name: "Р. + Б.",
        },
        {
          id: 3,
          name: "Реестры",
        },
        {
          id: 4,
          name: "Биржа",
        },
      ],

      rules: {
        // username: [
        //   {
        //     validator: usernameValidate,
        //     trigger: "blur",
        //     required: true,
        //   },
        // ],
        username: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          }
        ],
        password: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
          {
            min: 8,
            message: "В поле должно быть больше 8 символов",
            trigger: "blur",
          },
        ],
        fullName: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],
        organization: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters({
      organizations: "GETORGANIZATIONS",
      roleList: "GETROLELIST",
      managerList: "GETMANAGERLIST",
      OrganizationForManagerList: "GETORGANIZTIONFORMANAGERLIST",
    }),
  },

  methods: {
    changeRole() {
      console.log(this.user.organization);
      if (this.user.role.title === "ROLE_ECOLOG") {
        this.$store.dispatch("searchUsersForManager", {
          organizationId: this.user.organization.id,
          roleId: this.user.role.id,
        });
      }
      if (this.user.role.id == 3) {
        this.$store.dispatch("searchOrganizationForManager", {
          organizationId: this.user.organization.id,
        });
      }
      console.log(this);
    },

    addUser(formName) {
      this.user.prod =
        this.user.prod == false
          ? 0
          : this.user.prod == true
          ? 1
          : this.user.prod;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("addUser", this.user).then((response) => {
            console.log(response);
            this.notification("Успешно", "Создан пользователь", "success");
            this.$store.dispatch("getAllUsers", { page: 0, size: 20 });
            this.$store.dispatch("setShowModal", null);
          });
        } else {
          return false;
        }
      });
    },

    changeOrganization(organization) {
      if (!organization) {
        return;
      }
      this.$store.dispatch("searchOrganizationForManager", {
        organizationId: organization.id,
      });
    },

    searchOrganization(query) {
      this.getOrganizationList(query);
    },

    getOrganizationList(query) {
      let data = {
        query: query,
        page: 0,
        size: 20,
      };
      this.$store.dispatch("searchOrganizations", data);
    },
  },

  mounted() {
    this.user.prod =
      this.user.prod == 0 ? false : this.user.prod == 1 ? true : this.user.prod;
    this.$store.dispatch("getAllUserRoles");
  },
};
</script>

<style scoped></style>
